var Marionette = require('marionette')

var TabLabel = Marionette.View.extend({
  initialize: function (options) {},
  tagName: 'li',
  template: function (model) {
    return '<div class="m-tabs-item-label">' + model.label + '</div>'
  },
  events: {
    'click': function (event) {
      event.preventDefault()
      this.trigger('select', this)
    }
  },
  modelEvents: {
    'change': 'render'
  }
})

var TabLabelsContainer = Marionette.CollectionView.extend({
  tagName: 'ul',
  childView: TabLabel,
  childViewEvents: {
    'select': function (itemView) {
      this.trigger('change', itemView)
    }
  }

})

module.exports.TabLabel = TabLabel
module.exports.TabLabelsContainer = TabLabelsContainer



// WEBPACK FOOTER //
// ./js/behaviors/tabs/view.js